var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_135388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7792 15.6905L13.4889 12.3988C15.9508 9.1088 15.2795 4.44584 11.9895 1.98387C8.69943 -0.478099 4.03648 0.1932 1.57451 3.48325C-0.887461 6.7733 -0.216163 11.4363 3.07389 13.8982C5.71672 15.8759 9.34661 15.8759 11.9895 13.8982L15.2812 17.1899C15.6948 17.6036 16.3655 17.6036 16.7791 17.1899C17.1928 16.7763 17.1928 16.1056 16.7791 15.692L16.7792 15.6905ZM7.55911 13.2629C4.63508 13.2629 2.2647 10.8925 2.2647 7.96848C2.2647 5.04444 4.63508 2.67406 7.55911 2.67406C10.4832 2.67406 12.8535 5.04444 12.8535 7.96848C12.8504 10.8912 10.4819 13.2598 7.55911 13.2629Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_135388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0.0898438 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlack);
export default __webpack_public_path__ + "static/media/search-black.090144626c7ae8a8a4dd4786d012bb36.svg";
export { ForwardRef as ReactComponent };